import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useUserMcq } = getCRUDHooks({
  entityName: 'userMcq',
  get: async ({ userId, mcqIds }: { userId: number; mcqIds: number | number[] }) => {
    if (!userId || !mcqIds) {
      return { body: null };
    }

    const ids = typeof mcqIds === 'number' ? [mcqIds] : mcqIds;

    const headers = new Headers();
    headers.append('X-Requested-With', 'XMLHttpRequest');

    const options = {
      method: 'GET',
      headers,
    };

    const responses =
      // FIXME: use api when available
      await Promise.all(ids.map((id) => fetch(`/api/users/${userId}/mcq/${id}`, options)));
    const jsonResponses = await Promise.all(responses.map((response) => response.json()));
    return { body: jsonResponses };
  },
});

// eslint-disable-next-line import/prefer-default-export
export { useUserMcq };
